module.exports = __webpack_public_path__ + "img/so.f91fb92c.svg";